import { Box, GridLegacy as Grid, Typography } from '@mui/material';
import * as React from 'react';
import { FieldErrors, UseFormReturn } from 'react-hook-form';

import { OrgUnitFormData } from '~/scenes/PortalViews/Views/PortalAltMgr/components/OrgUnitPopup';

type PropsType = {
  form: UseFormReturn<OrgUnitFormData>;
};

export const OrgUnitFormErrors = (props: PropsType) => {
  const {
    form: {
      formState: { errors },
    },
  } = props;

  const renderErrors = (errors: FieldErrors) => {
    if (!errors) return null;
    return Object.entries(errors).map(([key, error]) => {
      if (key !== 'substituteStartDate' && key !== 'substituteEndDate') {
        if (error?.message) {
          return (
            <Typography key={key} color="error">
              {error.message}
            </Typography>
          );
        } else if (typeof error === 'object') {
          return <Box key={key}>{renderErrors(error as FieldErrors)}</Box>;
        }
      }
      return null;
    });
  };

  if (!Object.keys(errors).length) {
    return <></>;
  }

  return (
    <Grid item xs={12}>
      {renderErrors(errors)}
    </Grid>
  );
};
